/**************************************************
 * Nombre:       Tarjeta_Perfil
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";
import usu from '../../../../Recursos/usuario_defecto.jpg'
import {TEXTO, TEXTOCLARO} from "../../../ContantesColor";
import {MailOutline} from "@mui/icons-material";
import {acortarTexto} from "../../../Utilidades/acortarTexto";

const Tarjeta_Perfil = ({usuario}) => {

    return (
        <Grid
            container
            size={12}
            sx={{alignItems: 'center'}}
        >

            <Grid size={3}>
                <Avatar src={usuario.img ? usuario.img : usu} sx={{width: 80, height: 80}}/>
            </Grid>

            <Grid container size={9} spacing={0} sx={{alignItems: 'center', pl: 2}}>

                <Grid item size={12}>
                    <Typography sx={{
                        color: TEXTO,
                        fontSize: 14,
                        fontWeight: 500,
                    }}>{acortarTexto({texto: usuario.nombres + ' ' + usuario.apellidos, num: 20})}</Typography>
                </Grid>

                <Grid item size={12}>
                    <Typography sx={{
                        color: TEXTOCLARO,
                        fontSize: 14,
                        fontWeight: 500
                    }}> {usuario.tipo + ' ' + usuario.cc}</Typography>
                </Grid>

                <Grid item size={1}>
                    <MailOutline
                        sx={{width: 16, height: 16, fill: TEXTOCLARO, marginTop: 0.5}}/>
                </Grid>

                <Grid item size={11}>
                    <Typography sx={{
                        color: TEXTOCLARO,
                        fontSize: 14,
                        fontWeight: 500,
                        pl: 0.5,
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 1,
                        textOverflow: "ellipsis",
                    }}> {acortarTexto({texto: usuario.correo, num: 28})}</Typography>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Tarjeta_Perfil